import React from "react";

export const GifVideo = ({ fileName, classes }) => {

  return fileName && (
    <div
      dangerouslySetInnerHTML={{
        __html: `
          <video
             class="${classes}"
              poster="/illustrations/poster/${fileName}.jpeg"
              loop
              muted
              autoplay
              playsinline
              preload="auto"
            >
            <source src="/illustrations/webm/${fileName}.webm" type="video/webm" />
            <source src="/illustrations/mp4/${fileName}.mp4" type="video/mp4" />
          </video>`
      }}
    >
    </div>
  );
}
